// utils/findCategoryHierarchy.js
export const findCategoryHierarchy = (categories, params, productId = null) => {
  const { categoryName, subCategoryName, subSubCategoryName, subSubSubCategoryName } = params;

  for (const category of categories || []) {
    if (
      categoryName &&
      category.categoryName.toLowerCase().replace(/\s+/g, "-") === categoryName
    ) {
      if (productId) {
        // Find product in category or its subcategories
        for (const subCategory of category.subCategories || []) {
          if ((subCategory.products || []).some((p) => p._id === productId)) {
            return { category, subCategory, subSubCategory: null, subSubSubCategory: null };
          }
          for (const subSubCategory of subCategory.subSubCategories || []) {
            if ((subSubCategory.products || []).some((p) => p._id === productId)) {
              return { category, subCategory, subSubCategory, subSubSubCategory: null };
            }
            for (const subSubSubCategory of subSubCategory.subSubSubCategories || []) {
              if ((subSubSubCategory.products || []).some((p) => p._id === productId)) {
                return { category, subCategory, subSubCategory, subSubSubCategory };
              }
            }
          }
        }
      } else if (!subCategoryName) {
        return { category, subCategory: null, subSubCategory: null, subSubSubCategory: null };
      }

      for (const subCategory of category.subCategories || []) {
        if (
          subCategoryName &&
          subCategory.subCategoryName.toLowerCase().replace(/\s+/g, "-") === subCategoryName
        ) {
          if (!subSubCategoryName) {
            return { category, subCategory, subSubCategory: null, subSubSubCategory: null };
          }
          for (const subSubCategory of subCategory.subSubCategories || []) {
            if (
              subSubCategoryName &&
              subSubCategory.subSubCategoryName.toLowerCase().replace(/\s+/g, "-") === subSubCategoryName
            ) {
              if (!subSubSubCategoryName) {
                return { category, subCategory, subSubCategory, subSubSubCategory: null };
              }
              for (const subSubSubCategory of subSubCategory.subSubSubCategories || []) {
                if (
                  subSubSubCategoryName &&
                  subSubSubCategory.subSubSubCategoryName.toLowerCase().replace(/\s+/g, "-") === subSubSubCategoryName
                ) {
                  return { category, subCategory, subSubCategory, subSubSubCategory };
                }
              }
            }
          }
        }
      }
    }
  }
  return { category: null, subCategory: null, subSubCategory: null, subSubSubCategory: null };
};